// extracted by mini-css-extract-plugin
export default {"image_field":"Image-fld_image_field__coTH0","img_label":"Image-fld_img_label__JkBgp","add_img_block":"Image-fld_add_img_block__Cf5Wh","label_img":"Image-fld_label_img__SkwNK"};